// import { DgxIconName } from '@domgen/dgx-fe-components/icon';

import { DgxIconName } from '@domgen/dgx-fe-components/icon';

export interface SerializationCodeResponse {
  Brand_Code: string;
  Brand: string;
  Category_Code: string;
  Client__c: string;
  Client_Code: string;
  Country__c: string;
  Default_Guarantee_Period_Labor: number;
  Default_Guarantee_Period_Parts: number;
  icon: DgxIconName;
  Item_Type_Code: string;
  LoadDate: string;
  LoadFilename: string;
  Model_Number: string;
  Model_Reference: string;
  Serial_Number: string;
  Serialization_Code: string;
  Serialization_Provider: string;
  categoryCode: string;
  applianceCode: string;
  Type: string;
}
